<div class="fcp-snackbar {{ horizontal }} {{ vertical }} {{ size }}" *ngIf="show">
    <fcp-alert type="{{ type }}" size="{{ size }}">
        <ng-content></ng-content>
        <div class="fcp-snackbar-button" (click)="onClickAlertClosed()">
            <fcp-icon class="fcp-snackbar-button-icon" [icon]="['fas', 'times']"></fcp-icon>
        </div>
    </fcp-alert>
</div>
